import React from 'react';

import { Messages } from '~src/codegen/Localize';

interface EstimateTabProps {
  targetColName?: string;
  rowCountToGeocode?: number;
  lastRunInfo?: string;
}

export class EstimateTab extends React.PureComponent<EstimateTabProps, {}> {
  public render(): React.ReactNode {
    const { targetColName, lastRunInfo } = this.props;
    if (!targetColName) {
      return <div className='geocodingEstimateTabContent'>{Messages.geocodingConfigEstimateTabNoSelection()}</div>;
    }

    if (!lastRunInfo) {
      return (
        <div className='geocodingEstimateTabContent geocodingInfoTextBlock'>
          <div className='geocodingLargeText geocodingBoldText'>{Messages.geocodingConfigEstimateTabInfoTitle()}</div>
          <div>{Messages.geocodingConfigEstimateTabInfoParagraph1()}</div>
          <div>{Messages.geocodingConfigEstimateTabInfoParagraph2()}</div>
        </div>
      );
    }

    return (
      <div className='geocodingEstimateTabContent'>
        <div className='geocodingBoldText'>{Messages.geocodingConfigEstimateTabResultTitle()}</div>
        <div>{Messages.geocodingConfigEstimateTabResultRowCount()}</div>
        <div>{Messages.geocodingConfigEstimateTabResultLastRun()}</div>
      </div>
    );
  }
}
